'use client';
import React, { useState, useEffect } from 'react';
import SignUpFlow from './components/SignUpFlow';
import { useLiveSpots } from '@/hooks/useLiveSpots';

export default function MemberSignUpPage() {
  const { spotsRemaining, totalSpots, isLoaded } = useLiveSpots();

  return (
    <div className="min-h-screen bg-[#0F0F0F] flex flex-col">
      {/* Header */}
      <header className="h-16 border-b border-[#2A2A2A] flex items-center justify-between px-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-[#F59E0B] rounded-lg flex items-center justify-center">
            <span className="font-display font-bold text-[#0F0F0F] text-xs">BT</span>
          </div>
          <span className="font-display font-bold text-white text-sm">BidTrek Partner Network</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-[#6B7280]">
          <span
            className={`w-1.5 h-1.5 rounded-full ${
              isLoaded && spotsRemaining <= 50
                ? 'bg-[#EF4444]'
                : 'bg-[#F59E0B]'
            }`}
          />
          {isLoaded ? (
            <span className="font-mono">
              {spotsRemaining} of {totalSpots} spots remaining
            </span>
          ) : (
            <span className="font-mono animate-pulse">Loading spots…</span>
          )}
        </div>
      </header>

      <div className="flex-1 flex items-start justify-center px-6 py-12">
        <div className="w-full max-w-xl">
          <SignUpFlow />
        </div>
      </div>
    </div>
  );
}